<div id="header"></div>
<div id="content">
  <div class="mainContent">
    <mat-sidenav-container class="example-container">
      <mat-sidenav #sidenav mode="over">
        
        <div class="loginBtn">
          <a (click)="logout()">Log Out</a>
        </div>
      </mat-sidenav>
      <mat-sidenav-content>

        <app-header (toggleClick)="toggleClick($event)" [hidden]="currentUrl == '/auth/flash-screen'"></app-header>
        <router-outlet></router-outlet>
        <ngx-spinner bdColor="rgba(210, 210, 210,0.5)" size="medium" color="#fff" type="ball-scale-multiple">
          <div class="tbl-spinner ">
            <mat-progress-spinner color="primary" [diameter]="40" mode="indeterminate">
            </mat-progress-spinner>
          </div>
        </ngx-spinner>

      </mat-sidenav-content>
    </mat-sidenav-container>
    
  </div>
</div>
<div id="footer">&nbsp;
  <app-footer [hidden]="showFooter"></app-footer>
</div>